import Vue from 'vue'
import App from './App.vue'
import MuseUI from 'muse-ui';
import Loading from 'muse-ui-loading';
import router from './router'
import Message from 'muse-ui-message';
import 'muse-ui/dist/muse-ui.css';
import 'muse-ui-loading/dist/muse-ui-loading.css'; // load css
import 'muse-ui-message/dist/muse-ui-message.css';
const coordtransform = require('coordtransform')

Vue.use(MuseUI);
Vue.use(Loading);
Vue.use(Message);
Vue.config.productionTip = false
Vue.prototype.$coordtransform = coordtransform
// const whiteList=['/login'];
router.beforeEach((to, from, next) => {
  let userInfo = JSON.parse(window.localStorage.getItem('userinfo'))
  if (to.meta.requiresAuth) {
    if (userInfo) {
      if (to.path === '/login') {
        next('/')
      } else {
        next()
      }
    } else {
      next(`/login?redirect=${to.path}`) // 否则全部重定向到登录页
    }
  } else {
    next()
  }
})
new Vue({
  render: h => h(App),
  router
}).$mount('#app')
